import {collection, LocalisableEntityData} from "@fedeltapointofsale/data-client";

export class DocketSelectorAuditReportData extends LocalisableEntityData<DocketSelectorAuditReportData> {
    @collection() metaTags: number[];
}
